import classNames from 'classnames';
import { CategoryColor, Project } from '../api/api.ts';
import { gradientClassesForColor } from '../utils/Colors.ts';
import { useContext } from 'react';
import { LanguageContext } from '@/common/Language.tsx';

export const ProjectHeading = ({
  project,
  color,
}: {
  project: Project;
  color: CategoryColor;
}) => {
  const { t } = useContext(LanguageContext);
  const colorClasses = gradientClassesForColor(color);

  return (
    <h2 className={classNames('relative', 'mx-auto', 'pl-[24px]', 'pr-[36px]')}>
      {t(project.name, project.nameDe)}
      {color && (
        <div
          className={classNames(
            'absolute',
            'left-0',
            'top-0',
            'bottom-0',
            'w-[12px]',
            'rounded-[6px]',
            colorClasses
          )}
        ></div>
      )}
    </h2>
  );
};
